<template>
  <a-card :bordered="false">
    <!-- 查询区域 -->
    <div class="table-page-search-wrapper">
      <a-form @keyup.enter.native="getList" layout="inline">
        <a-row :gutter="24">
          <a-col :lg="5" :md="5" :sm="24" :xl="5" :xs="24">
            <a-form-item label="供水流域">
              <j-dict-select-tag
                @change="processChange"
                dictCode="`iwt-wf`.dev_process,process_name,id"
                placeholder="请选择供水流域"
                v-model="queryParam.devProcessId"
              />
            </a-form-item>
          </a-col>
          <a-col :lg="5" :md="5" :sm="24" :xl="5" :xs="24">
            <a-form-model-item label="设备">
              <j-search-select-tag
                :dict="
                  '`iwt-wf`.dev_list,dev_name,id' +
                    (queryParam.devProcessId ? `,dev_process_id=${queryParam.devProcessId} and del_flag=0` : ', del_flag=0') + 'order by sort asc'
                "
                :disabled="devDisabled"
                @change="getList"
                placeholder="请选择设备"
                v-model="queryParam.devId"
              />
            </a-form-model-item>
          </a-col>
          <a-col :lg="8" :md="8" :sm="24" :xl="8" :xs="24">
            <a-form-model-item label="缺陷状态">
              <j-multi-select-tag
                @change="getList"
                dictCode="def_status"
                placeholder="请选择"
                type="checkbox"
                v-model="queryParam.defStatusStr"
              ></j-multi-select-tag>
            </a-form-model-item>
          </a-col>

          <a-col :lg="4" :md="4" :sm="24" :xl="4" :xs="24">
            <a-form-model-item label="类型">
              <j-multi-select-tag
                @change="getList"
                dictCode="def_type"
                placeholder="请选择"
                type="checkbox"
                v-model="queryParam.defType"
              ></j-multi-select-tag>
            </a-form-model-item>
          </a-col>
          <a-col :lg="6" :md="6" :sm="24" :xl="6" :xs="24">
            <a-form-model-item label="缺陷等级">
              <j-multi-select-tag
                @change="getList"
                dictCode="def_level"
                placeholder="请选择"
                type="checkbox"
                v-model="queryParam.defLevel"
              ></j-multi-select-tag>
            </a-form-model-item>
          </a-col>

          <a-col :lg="5" :md="5" :sm="24" :xl="5" :xs="24">
            <a-form-model-item label="发现人">
              <j-dict-select-tag
                :dictCode="
                  `sys_user,realname,id,del_flag='0' and executor_maintain = 1 and rel_tenant_ids='${this.$ls.get(
                    'TENANT_ID'
                  )}' order by realname`
                "
                pageSize="100"
                placeholder="请选择缺陷发现人"
                type="list"
                v-model="queryParam.defInventor"
              />
            </a-form-model-item>
          </a-col>
          <a-col :lg="8" :md="8" :sm="24" :xl="8" :xs="24">
            <a-form-model-item label="发现日期">
              <a-range-picker
                :placeholder="['开始时间', '结束时间']"
                @change="getList"
                format="YYYY-MM-DD"
                v-model="timeRange"
                valueFormat="YYYY-MM-DD"
              />
            </a-form-model-item>
          </a-col>
          <a-col :lg="1" :md="1" :sm="24" :xl="1" :xs="24">
            <a-button @click="getList" icon="search" type="primary">查询</a-button>
          </a-col>
        </a-row>
      </a-form>
    </div>
    <!-- 查询区域-END -->

    <!-- 操作按钮区域 -->
    <div class="table-operator">
      <a-button @click="handleAdd" icon="plus" type="primary">新增</a-button>
      <a-button @click="handleExportXls('缺陷登记')" icon="download" type="primary">导出</a-button>
      <a-upload
        :action="importExcelUrl"
        :headers="tokenHeader"
        :multiple="false"
        :showUploadList="false"
        @change="handleImportExcel"
        name="file"
      >
        <a-button icon="import" type="primary">导入</a-button>
      </a-upload>
      <!-- 高级查询区域 -->
      <j-super-query :fieldList="superFieldList" @handleSuperQuery="handleSuperQuery" ref="superQueryModal"></j-super-query>
      <a-dropdown v-if="selectedRowKeys.length > 0">
        <a-menu slot="overlay">
          <a-menu-item @click="batchDel" key="1">
            <a-icon type="delete" />删除
          </a-menu-item>
        </a-menu>
        <a-button style="margin-left: 8px">
          批量操作
          <a-icon type="down" />
        </a-button>
      </a-dropdown>
    </div>

    <!-- table区域-begin -->
    <div>
      <div class="ant-alert ant-alert-info" style="margin-bottom: 16px;">
        <i class="anticon anticon-info-circle ant-alert-icon"></i> 已选择
        <a style="font-weight: 600">{{ selectedRowKeys.length }}</a>项
        <a @click="onClearSelected" style="margin-left: 24px">清空</a>
      </div>
      <a-table
        :columns="columns"
        :dataSource="dataSource"
        :loading="loading"
        :pagination="ipagination"
        :rowSelection="{ selectedRowKeys: selectedRowKeys, onChange: onSelectChange }"
        :scroll="{ x: true }"
        @change="handleTableChange"
        bordered
        class="j-table-force-nowrap"
        ref="table"
        rowKey="id"
        size="middle"
      >
        <span slot="defType" slot-scope="defType, record">
          <span v-if="record.defType == 1">
            <a-tag>设备类型</a-tag>
          </span>
          <span v-else-if="record.defType == 2">
            <a-tag>非设备类型</a-tag>
          </span>
        </span>
        <span slot="defLevel" slot-scope="priority, record">
          <!-- 	def_level_color -->
          <a-tag :color="$filterDictTextByCache('def_level_color', record.defLevel)">
            {{
            record.defLevel_dictText
            }}
          </a-tag>
        </span>
        <span slot="devName" slot-scope="text, record">
          <link-to-detail :id="record.devId" pageType="drawer" route-name="FusionDevice">
            <span>{{ text }}</span>
          </link-to-detail>
        </span>
        <span slot="defInventor" slot-scope="text, record">
          <a-button @click="showStatReport(record, 'personDefReport', 'defInventor', 'userId')" type="link">
            {{
            text
            }}
          </a-button>
        </span>
        <span slot="defHandle" slot-scope="text, record">
          <a-button @click="showStatReport(record, 'personDefReport', 'defHandle', 'userId')" type="link">
            {{
            text
            }}
          </a-button>
        </span>
        <template slot="htmlSlot" slot-scope="text">
          <div v-html="text"></div>
        </template>
        <template slot="imgSlot" slot-scope="text">
          <span style="font-size: 12px;font-style: italic;" v-if="!text">无图片</span>
          <img
            :src="getImgView(text)"
            alt
            height="25px"
            style="max-width:80px;font-size: 12px;font-style: italic;"
            v-else
          />
        </template>
        <template slot="fileSlot" slot-scope="text">
          <span style="font-size: 12px;font-style: italic;" v-if="!text">无文件</span>
          <a-button :ghost="true" @click="downloadFile(text)" icon="download" size="small" type="primary" v-else>下载</a-button>
        </template>
        <span slot="action" slot-scope="text, record">
          <a @click="handleClose(record)" v-if="record.defStatus == 0">不是缺陷</a>
          <a-divider type="vertical" v-if="record.defStatus == 0" />
          <a @click="handleEdit(record)" v-if="record.defStatus == 0 || record.defStatus == 4">编辑</a>
          <a-divider type="vertical" v-if="record.defStatus == 0 || record.defStatus == 4" />
          <a @click="handlePublish(record)" v-if="record.defStatus == 0 || record.defStatus == 4">发布</a>
          <a-divider type="vertical" v-if="record.defStatus == 0 || record.defStatus == 4" />
          <a @click="handleDefStandard(record)" v-if="record.defStatus == 1 || record.defStatus == 2">处理</a>
          <a-divider type="vertical" v-if="record.defStatus == 1 || record.defStatus == 2" />
          <a @click="handleEvntCirculationHistory(record)" v-if="record.defStatus != 0">消缺记录</a>
          <a-divider type="vertical" v-if="record.defStatus != 0" />
          <!-- <a @click="handleHangUp(record)" v-if="record.defStatus == 1 || record.defStatus == 2">挂起</a>
          <a-divider type="vertical" v-if="record.defStatus == 1 || record.defStatus == 2" />-->
          <a-dropdown>
            <a class="ant-dropdown-link">
              更多
              <a-icon type="down" />
            </a>
            <a-menu slot="overlay">
              <a-menu-item>
                <a @click="handleDetail(record)">详情</a>
              </a-menu-item>
              <a-menu-item>
                <a-popconfirm @confirm="() => handleDelete(record.id)" title="确定删除吗?">
                  <a>删除</a>
                </a-popconfirm>
              </a-menu-item>
            </a-menu>
          </a-dropdown>
        </span>
      </a-table>
    </div>
    <def-register-modal @ok="modalFormOk" ref="modalForm"></def-register-modal>
    <evnt-process-info-modal @ok="modalFormOk" ref="evntForm"></evnt-process-info-modal>
    <def-handle-list ref="defHandleList"></def-handle-list>

    <iframe-drawer ref="iframeDrawer"></iframe-drawer>
  </a-card>
</template>

<script>
  import { httpAction, getAction, putAction, postAction } from '@/api/manage'
  import '@/assets/less/TableExpand.less'
  import { mixinDevice } from '@/utils/mixin'
  import { JeecgListMixin } from '@/mixins/JeecgListMixin'
  import DefRegisterModal from './modules/DefRegisterModal'
  import EvntProcessInfoModal from './modules/EvntProcessInfoModal'
  import { getUserList } from '@/api/api'
  import { filterMultiDictText } from '@/components/dict/JDictSelectUtil'
  import { validatenull, validatenotnull } from '@/utils/validate'
  import DefHandleList from './DefHandleList'
  import moment from 'moment'

  export default {
    name: 'DefRegisterList',
    mixins: [JeecgListMixin, mixinDevice],
    components: {
      DefRegisterModal,
      EvntProcessInfoModal,
      DefHandleList
    },
    data () {
      return {
        timeRange: [],
        devClassList: [],
        UserOptions: [],
        description: '缺陷登记管理页面',
        dateFormat: 'YYYY-MM-DD',
        queryParam: {
          defType: '1,2',
          defStatusStr: '0,1,2'
        },
        // 表头
        columns: [
          {
            title: '#',
            dataIndex: '',
            key: 'rowIndex',
            width: 60,
            align: 'center',
            customRender: function (t, r, index) {
              return parseInt(index) + 1
            }
          },
          /*  {
               title: '缺陷类型',
               align: "center",
               dataIndex: 'defType',
               scopedSlots: { customRender: 'defType' },
           }, */
          {
            title: '设备名称',
            align: 'center',
            dataIndex: 'devName',
            scopedSlots: { customRender: 'devName' },
            sorter: true
          },
          {
            title: '缺陷内容',
            align: 'center',
            dataIndex: 'defContent'
          },
          {
            title: '缺陷部位',
            align: 'center',
            dataIndex: 'defPart'
          },
          {
            title: '缺陷类别',
            align: 'center',
            dataIndex: 'defCategory'
          },
          {
            title: '缺陷等级',
            align: 'center',
            dataIndex: 'defLevel',
            scopedSlots: { customRender: 'defLevel' },
            sorter: true
          },
          {
            title: '缺陷发现人',
            align: 'center',
            //defInventor
            dataIndex: 'defInventor_dictText',
            scopedSlots: { customRender: 'defInventor' }
          },
          {
            title: '缺陷处理人',
            align: 'center',
            dataIndex: 'defHandle_dictText',
            scopedSlots: { customRender: 'defHandle' }
          },
          {
            title: '缺陷发现时间',
            align: 'center',
            dataIndex: 'defFindTime',
            width: 180,
            sorter: true
          },
          {
            title: '当前状态',
            align: 'center',
            dataIndex: 'defStatus_dictText',
            sorter: true
          },
          {
            title: '操作',
            dataIndex: 'action',
            align: 'center',
            fixed: 'right',
            width: 250,
            scopedSlots: { customRender: 'action' }
          }
        ],
        url: {
          list: '/device/defRegister/list',
          delete: '/device/defRegister/delete',
          deleteBatch: '/device/defRegister/deleteBatch',
          exportXlsUrl: '/device/defRegister/exportXls',
          importExcelUrl: 'org.jeecg.modules.device/defRegister/importExcel',
          selectClass: '/device/devClass/selectDropList',
          putById: '/device/defRegister/edit',
          publishUrl: '/device/defRegister/publish',
          hangUpUrl: '/device/defRegister/hangUp',
          handle: '/device/defRegister/handle',
          getReportUrl: '/custom/commonOnlReport/list'
        },
        dictOptions: {},
        superFieldList: [],
        isorter: {
          column: 'defFindTime',
          order: 'desc'
        },
        devDisabled: false,
        reportUrl: {}
      }
    },
    created () {
      this.getSuperFieldList()
      this.getClassList()

      const that = this
      getAction(this.url.getReportUrl, { reportGroup: 'drill-ana' }).then(res => {
        if (res.success && res.result) {
          res.result.records.forEach(rep => {
            that.reportUrl[rep.shortName] = rep.url
          })
        }
      })
    },
    computed: {
      importExcelUrl: function () {
        return `${window._CONFIG['domianURL']}/${this.url.importExcelUrl}`
      },
      userInfo () {
        return this.$store.getters.userInfo
      }
    },
    methods: {
      processChange () {
        this.queryParam.devId = null
        this.getList()
      },
      getList () {
        if (validatenotnull(this.queryParam.defType) && this.queryParam.defType.indexOf('1') == -1) {
          this.queryParam.devId = ''
          this.devDisabled = true
        } else {
          this.devDisabled = false
        }
        if (validatenull(this.timeRange)) {
          this.queryParam.startTime = ''
          this.queryParam.endTime = ''
        } else {
          this.queryParam.startTime = this.timeRange[0]
          this.queryParam.endTime = this.timeRange[1]
        }
        this.searchQuery()
      },
      initDictConfig () { },
      getSuperFieldList () {
        let fieldList = []
        fieldList.push({ type: 'string', value: 'defType', text: '缺陷类型', dictCode: '' })
        fieldList.push({ type: 'string', value: 'devId', text: '设备id', dictCode: '' })
        fieldList.push({ type: 'string', value: 'devName', text: '设备名称', dictCode: '' })
        fieldList.push({ type: 'string', value: 'devClassId', text: '设备类型id', dictCode: '' })
        fieldList.push({ type: 'string', value: 'defStandardId', text: '缺陷标准id', dictCode: '' })
        fieldList.push({ type: 'string', value: 'defStandardName', text: '缺陷标准名称', dictCode: '' })
        fieldList.push({ type: 'string', value: 'defLevel', text: '缺陷等级', dictCode: '' })
        fieldList.push({ type: 'string', value: 'defContent', text: '缺陷内容', dictCode: '' })
        fieldList.push({ type: 'string', value: 'defPicture', text: '缺陷图片', dictCode: '' })
        fieldList.push({ type: 'string', value: 'defInventor', text: '缺陷发现人', dictCode: '' })
        fieldList.push({ type: 'string', value: 'defTelephone', text: '联系电话', dictCode: '' })
        fieldList.push({ type: 'string', value: 'startTime', text: '缺陷发现开始时间', dictCode: '' })
        fieldList.push({ type: 'string', value: 'endTime', text: '缺陷发现结束时间', dictCode: '' })
        fieldList.push({ type: 'int', value: 'defStatus', text: '当前状态', dictCode: 'def_status' })
        fieldList.push({ type: 'string', value: 'tenantId', text: '租户id', dictCode: '' })
        fieldList.push({ type: 'int', value: 'delFlag', text: '删除状态', dictCode: '' })
        this.superFieldList = fieldList
      },
      getClassList () {
        getAction(this.url.selectClass, {}).then(res => {
          this.devClassList = res.result.records.map(item => {
            return {
              value: item.id,
              label: item.typeName
            }
          })
        })
      },
      remoteUserList (query) {
        let params = {
          username: query
          // realname: query,
          // phone: query,
          // workNo: query
        }
        let sqp = {}
        // sqp['superQueryParams'] = encodeURI(params)
        // sqp['superQueryMatchType'] = 'or'
        getUserList(Object.assign(sqp, { pageSize: 999999 })).then(res => {
          this.UserOptions = res.result.records
        })
      },
      filterOption (input, option) {
        return option.componentOptions.children[0].text.toLowerCase().indexOf(input.toLowerCase()) >= 0
      },
      handleClose (row) {
        const that = this
        if (row.defStatus != 0) {
          this.$message.error('该状态不允许,请确认状态是否合法.')
        }
        //点击后直接将缺陷状态改为“已处理”，处理过程是“定性后，确定此事件不是缺陷”
        const handleData = {
          id: row.id,
          handleTime: moment(new Date(), 'YYYY-MM-DD HH:mm:ss').format('YYYY-MM-DD HH:mm:ss'), //默认值
          defHandle: this.userInfo.id,
          status: 3,
          formData: {
            picture: [],
            description: '定性后，确定此事件不是缺陷'
          }
        }
        httpAction(this.url.handle, handleData, 'post')
          .then(res => {
            if (res.success) {
              that.$message.success(res.message)
              that.$emit('ok')
            } else {
              that.$message.warning(res.message)
            }
          })
          .finally(() => {
            that.confirmLoading = false
            this.getList()
          })
      },
      handlePublish (row) {
        if (row.defStatus != 0 && row.defStatus != 4) {
          this.$message.error('该状态不允许发布,请确认状态是否合法.')
        }
        //发布
        postAction(this.url.publishUrl, row).then(res => {
          if (res.success) {
            this.$message.success('缺陷发布成功.')
            this.getList()
          } else {
            this.$message.error(res.message)
          }
        })
      },
      handleHangUp (row) {
        if (row.defStatus != 1 && row.defStatus != 2 && row.defStatus != 3) {
          this.$message.error('该状态不允许挂起,请确认状态是否合法.')
        }
        //挂起
        postAction(this.url.hangUpUrl, row).then(res => {
          if (res.success) {
            this.$message.success('缺陷挂起成功.')
            this.getList()
          } else {
            this.$message.error(res.message)
          }
        })
      },
      //处理缺陷登记
      handleDefStandard: function (record) {
        this.$refs.evntForm.edit(record)
        this.$refs.evntForm.title = '缺陷处理'
        this.$refs.evntForm.disableSubmit = false
      },
      //查询消缺记录
      handleEvntCirculationHistory: function (record) {
        this.$refs.defHandleList.init(record.id)
      },
      showStatReport (record, reportKey, key, paramKey) {
        let url = this.reportUrl[reportKey]
        if (!url) {
          this.$message.warning('未找到统计信息配置')
        }
        if (url.indexOf(`${paramKey}`) > -1) {
          url = url.replace(`\$\{${paramKey}\}`, record[key])
        } else {
          url += `&${paramKey}=${record[key]}`
        }
        this.$refs['iframeDrawer'].show(url)
      }
    }
  }
</script>
<style scoped>

  @import '~@assets/less/common.less';

</style>
